import { useMemo } from 'react';
import { routes } from './routes';

export function useEncounterModuleRoute() {
  return useMemo(() => {
    return {
      path: '/encounter/:encounterId',
      lazy: () =>
        import('./Encounters.Module/EncounterPageModule').then(({ EncounterPageModule }) => ({
          Component: EncounterPageModule,
        })),
      children: routes([
        {
          index: true,
          lazy: () =>
            import('./Encounters.Details/EncounterHistoryPage').then(({ EncounterHistoryPage }) => ({
              Component: EncounterHistoryPage,
            })),
        },
        {
          path: 'examination',
          lazy: () =>
            import('./Encounters.Details/EncounterExaminationPage').then(({ EncounterExaminationPage }) => ({
              Component: EncounterExaminationPage,
            })),
        },
        {
          path: 'summary',
          lazy: () =>
            import('./Encounters.Details/EncounterSummaryPage').then(({ EncounterSummaryPage }) => ({
              Component: EncounterSummaryPage,
            })),
        },
        {
          path: 'document',
          lazy: () =>
            import('./Encounters.Documents.List/EncounterDocumentsListPage').then(
              ({ EncounterDocumentsListPage }) => ({
                Component: EncounterDocumentsListPage,
              }),
            ),
        },
      ]),
    };
  }, []);
}
